import { getDashboardHostApiInternal } from "../../externalApi/DashboardHostImpl";
import { getAccentColorRamp, getHostThemeApi } from "../../externalApi/ThemeApi";
import { isFeatureEnabled } from "../../externalApi/VelocityApi";
import widgetApiVersion from "../apis/api.interfaces";
import { WidgetApi } from "../orchestrator/WidgetApi";
import { getUriForResource } from "../registrar/registrarHelpers";
import { getResources } from "../../getResources";
export class WidgetProperties extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._properties = new Map();
        this._propertyChangeEvent = new Array();
        this._isUserSignedIn = true;
        if (isFeatureEnabled("Feature_AuthApiV5")) {
            // We must wait for Outlook to tell us if we are signed out
            if (widgetInstance.isOutlookWidget()) {
                const statusApi = widgetInstance.tryGetApi("status", 1, widgetApiVersion);
                if (statusApi) {
                    statusApi.addStatusEventListenerInternal((eventName) => { this.onHandleSignInEvent(eventName); });
                }
            }
        }
        //Handle theme information from the host as properties on the widget.
        let themeApiPromise = getHostThemeApi();
        themeApiPromise.then(async (themeApi) => {
            if (themeApi) {
                this.onThemeChanged(await themeApi.getBasicThemeColorPair());
                this.setProperty("animationsEnabled", await themeApi.animationsEnabled);
                this.setProperty("advancedEffectsEnabled", await themeApi.advancedEffectsEnabled);
                this.setProperty("autohideScrollbars", await themeApi.autoHideScrollBars);
                this.setProperty("accentColorRamp", await getAccentColorRamp());
                themeApi.addEventListener("themechanged", async () => {
                    this.onThemeChanged(await themeApi.getBasicThemeColorPair());
                    this.setProperty("accentColorRamp", await getAccentColorRamp());
                });
                themeApi.addEventListener("animationsenabledchanged", async () => {
                    this.setProperty("animationsEnabled", await themeApi.animationsEnabled);
                });
                themeApi.addEventListener("advancedeffectsenabledchanged", async () => {
                    this.setProperty("advancedEffectsEnabled", await themeApi.advancedEffectsEnabled);
                });
                themeApi.addEventListener("autohidescrollbarschanged", async () => {
                    this.setProperty("autohideScrollbars", await themeApi.autoHideScrollBars);
                });
            }
        });
        let dashboardHostApi = getDashboardHostApiInternal();
        if (dashboardHostApi) {
            this.setProperty("sessionId", dashboardHostApi.sessionId);
            this.setProperty("region", dashboardHostApi.userGeoName);
            this.setProperty("displayLocale", dashboardHostApi.userDisplayLocale);
            this.setProperty("hostVersion", dashboardHostApi.hostAppVersion);
            this.setProperty("offline", !dashboardHostApi.isInternetConnectionAvailable);
            dashboardHostApi.addEventListener("networkstatuschanged", () => {
                this.setProperty("offline", !dashboardHostApi.isInternetConnectionAvailable);
            });
            dashboardHostApi.addEventListener("sessionidchanged", () => {
                this.setProperty("sessionId", dashboardHostApi.sessionId);
            });
        }
        // These properties need to re-fetch on registration changes
        this.title = widgetInstance.widgetRegistration.displayName;
        this.activationUrl = widgetInstance.widgetRegistration.activationUrl;
        this.attribution = widgetInstance.widgetRegistration.attributionString;
        this.setProperty("widgetIconUri", getUriForResource(widgetInstance.widgetRegistration.id, widgetInstance.widgetRegistration.icon.src));
    }
    onHandleSignInEvent(eventName) {
        if (isFeatureEnabled("Feature_AuthApiV5")) {
            if (eventName == "onSignedIn") {
                this._isUserSignedIn = true;
            }
            else if (eventName == "onSignedOut") {
                this._isUserSignedIn = false;
            }
            this.overrideOutlookAttribution();
        }
    }
    get title() {
        return this.getProperty("title");
    }
    set title(title) {
        this.setProperty("title", title);
    }
    get attribution() {
        return this.getProperty("attribution");
    }
    set attribution(attribution) {
        if (isFeatureEnabled("Feature_AuthApiV5")) {
            this.overrideOutlookAttribution();
        }
        else {
            this.setProperty("attribution", attribution);
        }
    }
    get activationUrl() {
        return this.getProperty("activationUrl");
    }
    set activationUrl(activationUrl) {
        this.setProperty("activationUrl", activationUrl);
    }
    getProperty(name) {
        // expose column and position from internal properties as read-only
        if (name === "column" || name === "position") {
            return this._widgetInstance.getWidgetProperty(name);
        }
        if (this._properties.has(name)) {
            return this._properties.get(name);
        }
        else {
            return "";
        }
    }
    setProperty(name, value) {
        let notify = !this._properties.has(name) || this._properties.get(name) !== value;
        this._properties.set(name, value);
        if (notify) {
            this.onPropertyChange(name);
        }
    }
    addPropertyChangeListener(listener) {
        this._propertyChangeEvent.push(listener);
    }
    removePropertyChangeListener(listener) {
        let index = this._propertyChangeEvent.indexOf(listener);
        if (index > -1) {
            this._propertyChangeEvent.splice(index, 1);
        }
    }
    onRegistrationChanged() {
        // These properties need to re-fetch on registration changes
        this.title = this._widgetInstance.widgetRegistration.displayName;
        this.activationUrl = this._widgetInstance.widgetRegistration.activationUrl;
        this.attribution = this._widgetInstance.widgetRegistration.attributionString;
        this.setProperty("widgetIconUri", getUriForResource(this._widgetInstance.widgetRegistration.id, this._widgetInstance.widgetRegistration.icon.src));
    }
    onPropertyChange(name) {
        for (let index = 0; index < this._propertyChangeEvent.length; index++) {
            if (this._propertyChangeEvent[index]) {
                this._propertyChangeEvent[index](name);
            }
        }
    }
    onThemeChanged(colorPair) {
        this.setProperty("colorMode", colorPair.split(";")[0] === "000000" ? "dark" : "light");
        this.setProperty("accentColor", colorPair.split(";")[1]);
    }
    overrideOutlookAttribution() {
        if (this._widgetInstance.isOutlookWidget()) {
            if (this._isUserSignedIn) {
                this.setProperty("attribution", getResources().OutlookSignedInContextMenu_Attribution);
            }
            else {
                this.setProperty("attribution", getResources().OutlookSignedOutContextMenu_Attribution);
            }
        }
    }
}
